import { categoryConst } from "../constants/categoryConst";
import { categoryService } from "../../services/API/categoryService";
import auth from "../../services/auth";
import { history } from "../store/configureStore";
export const categoriesActions = {
  addCategory,
  getCategory,
  statusCategory,
  deleteCategory,
  getCategoryById,
  getCategoryDetail,
  updateCategory,
  uploadPhoto,
  getAllCategory,
  getParentCategories,
  getCategories,
  getAllCategories,
  getSubCategories
};

function addCategory(category) {
  return dispatch => {
    dispatch(request(category));
    categoryService.addCategory(category).then(
      category => {
        dispatch(success(category));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(category) {
    return { type: categoryConst.ADD_CATEGORY, category };
  }
  function success(category) {
    return { type: categoryConst.ADD_CATEGORY_SUCCESS, category };
  }
  function failure(error) {
    return { type: categoryConst.ADD_CATEGORY_FAILURE, error };
  }
}

function uploadPhoto(category) {
  return dispatch => {
    dispatch(request(category));
    categoryService.uploadPhoto(category).then(
      category => {
        dispatch(success(category));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(category) {
    return { type: categoryConst.ADD_CATEGORY, category };
  }
  function success(category) {
    return { type: categoryConst.ADD_CATEGORY_SUCCESS, category };
  }
  function failure(error) {
    return { type: categoryConst.ADD_CATEGORY_FAILURE, error };
  }
}

function updateCategory(category) {
  return dispatch => {
    dispatch(request(category));
    categoryService.updateCategory(category).then(
      category => {
        dispatch(success(category));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(category) {
    return { type: categoryConst.UPDATE_CATEGORY, category };
  }
  function success(category) {
    return { type: categoryConst.UPDATE_CATEGORY_SUCCESS, category };
  }
  function failure(error) {
    return { type: categoryConst.UPDATE_CATEGORY_FAILURE, error };
  }
}

function getCategory(page) {
  return dispatch => {
    categoryService.getCategory(page).then(
      category => {
        dispatch(success(category));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(category) {
    return { type: categoryConst.VIEW_CATEGORY, category };
  }
  function success(category) {
    return { type: categoryConst.VIEW_CATEGORY_SUCCESS, category };
  }
  function failure(error) {
    return { type: categoryConst.VIEW_CATEGORY_FAILURE, error };
  }
}

function getCategoryById(id, page, search, limit) {
  return dispatch => {
    categoryService.getCategoryById(id, page, search, limit).then(
      category => {
        dispatch(success(category));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: categoryConst.VIEW_SUB_CATEGORY_REQUEST, data };
  }
  function success(data) {
    return { type: categoryConst.VIEW_SUB_CATEGORY_SUCCESS, data };
  }
  function failure(error) {
    return { type: categoryConst.VIEW_SUB_CATEGORY_FAILURE, error };
  }
}

function getAllCategory(formdata) {
  return dispatch => {
    categoryService.getCategory(formdata).then(
      allcategory => {
        dispatch(success(allcategory));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(allcategory) {
    return { type: categoryConst.VIEW_ALL_CATEGORY_REQUEST, allcategory };
  }
  function success(allcategory) {
    return { type: categoryConst.VIEW_ALL_CATEGORY_SUCCESS, allcategory };
  }
  function failure(error) {
    return { type: categoryConst.VIEW_ALL_CATEGORY_FAILURE, error };
  }
}

export const getAllCategories = formdata => {
  return dispatch => {
    categoryService.getCategory(formdata).then(
      allcategory => {
        dispatch(success(allcategory));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(allcategory) {
    return { type: categoryConst.VIEW_ALL_CATEGORY_REQUEST, allcategory };
  }
  function success(allcategory) {
    return { type: categoryConst.VIEW_ALL_CATEGORY_SUCCESS, allcategory };
  }
  function failure(error) {
    return { type: categoryConst.VIEW_ALL_CATEGORY_FAILURE, error };
  }
};
export const getAllCategorys = formData => {
  return dispatch => {
    categoryService.getAllCategory(formData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(allcategory) {
    return { type: categoryConst.VIEW_ALL_CATEGORY_REQUEST, allcategory };
  }
  function success(allcategory) {
    return { type: categoryConst.VIEW_ALL_CATEGORY_SUCCESS, allcategory };
  }
  function failure(error) {
    return { type: categoryConst.VIEW_ALL_CATEGORY_FAILURE, error };
  }
};

export const getCategories = page => {
  return dispatch => {
    categoryService.getCategory(page).then(
      allcategory => {
        dispatch(success(allcategory));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(allcategory) {
    return { type: categoryConst.VIEW_ALL_CATEGORY_REQUEST, allcategory };
  }
  function success(allcategory) {
    return { type: categoryConst.VIEW_ALL_CATEGORY_SUCCESS, allcategory };
  }
  function failure(error) {
    return { type: categoryConst.VIEW_ALL_CATEGORY_FAILURE, error };
  }
};

function getCategoryDetail(id) {
  return dispatch => {
    categoryService.getCategoryDetail(id).then(
      category => {
        dispatch(success(category));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(category) {
    return { type: categoryConst.VIEW_CATEGORY_DETAIL, category };
  }
  function success(category) {
    return { type: categoryConst.VIEW_CATEGORY_DETAIL_SUCCESS, category };
  }
  function failure(error) {
    return { type: categoryConst.VIEW_CATEGORY_DETAIL_FAILURE, error };
  }
}

function deleteCategory(catID) {
  return dispatch => {
    categoryService.deleteCategory(catID, status).then(
      category => {
        dispatch(success(category));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(category) {
    return { type: categoryConst.DELETE_CATEGORY, category };
  }
  function success(category) {
    return { type: categoryConst.DELETE_CATEGORY_SUCCESS, category };
  }
  function failure(error) {
    return { type: categoryConst.DELETE_CATEGORY_FAILURE, error };
  }
}

function statusCategory(catID, status) {
  return dispatch => {
    categoryService.statusCategory(catID, status).then(
      category => {
        dispatch(success(category));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(category) {
    return { type: categoryConst.STATUS_CATEGORY, category };
  }
  function success(category) {
    return { type: categoryConst.STATUS_CATEGORY_SUCCESS, category };
  }
  function failure(error) {
    return { type: categoryConst.STATUS_CATEGORY_FAILURE, error };
  }
}

function getParentCategories() {
  return dispatch => {
    categoryService.getParentCategories().then(
      pcategory => {
        dispatch(success(pcategory));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(pcategory) {
    return { type: categoryConst.VIEW_PARENT_CATEGORY, pcategory };
  }
  function success(pcategory) {
    return { type: categoryConst.VIEW_PARENT_CATEGORY_SUCCESS, pcategory };
  }
  function failure(error) {
    return { type: categoryConst.VIEW_PARENT_CATEGORY_FAILURE, error };
  }
}

function getSubCategories(parentID, sub_cat_id) {
  return dispatch => {
    categoryService.getSubCategories(parentID, sub_cat_id).then(
      category => {
        dispatch(success(category));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: categoryConst.VIEW_SECONDSUB_CATEGORY_REQUEST, data };
  }
  function success(data) {
    return { type: categoryConst.VIEW_SECONDSUB_CATEGORY_SUCCESS, data };
  }
  function failure(error) {
    return { type: categoryConst.VIEW_SECONDSUB_CATEGORY_FAILURE, error };
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/actions/categories.js